import styled from "styled-components";

export const SideNavWrapper = styled.nav`
  display: flex;
  min-width: 375px;
  padding: 32px;
  flex-direction: column;
  align-items: flex-start;
  gap: 10px;
  align-self: stretch;
  border-right: 1px solid ${({ theme }) => theme.colors.default[100]};
  position: sticky;
  top: 61px;
  height: fit-content;

  ${({ theme }) => theme.breakpoints.md.query} {
    display: none;
  }
`;

export const SideNavItem = styled.div`
  width: 100%;
  display: flex;
  padding-left: 10px;
  justify-content: space-between;
  align-items: center;
  align-self: stretch;
  color: ${({ theme }) => theme.colors.default[600]};
`;

export const IconTextGroup = styled.div`
  display: flex;
  align-items: start;
  gap: 10px;
  width: 100%;

  & > svg {
    margin-top: 1.5px;
  }
`;

export const SubItem = styled.div`
  width: 100%;
  padding: 6px 6px 6px 45px;
  transition: 0.2s;

  &:hover {
    color: ${({ theme }) => theme.colors.default[300]};
  }
`;
